export default {
  title: 'SEO',
  subtitle:
    'Personnalisez le titre et la description qui apparaissent dans les résultats Google et les aperçus sociaux. Laissez vide pour utiliser les valeurs par défaut.',
  fields: {
    title: {
      label: 'Titre de la page',
      placeholder: 'ex. : Forza Napoli — pizza napolitaine authentique à Munich',
      help: "Affiché en titre dans les résultats Google et les onglets du navigateur. Jusqu'à 255 caractères ; visez 50–60 pour un meilleur aperçu.",
    },
    description: {
      label: 'Méta description',
      placeholder: 'Bref résumé de votre restaurant qui apparaîtra sous le titre dans les résultats de recherche.',
      help: "Jusqu'à 500 caractères ; Google en affiche généralement 150–160. Mettez en avant ce qui rend votre restaurant unique.",
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    saved: 'Paramètres SEO enregistrés',
    failed: "Échec de l'enregistrement des paramètres SEO",
  },
};
